

export const xpathParser = (xpath) => {
  if (!xpath) return null

  const xpathArr = xpath.split(':')
  const xpathName = xpathArr[xpathArr.length - 1]

  return xpathName
}



// WEBPACK FOOTER //
// ./src/utils/xpathParser.js